import { render, staticRenderFns } from "./Locale.vue?vue&type=template&id=7522794c&"
import script from "./Locale.vue?vue&type=script&lang=ts&"
export * from "./Locale.vue?vue&type=script&lang=ts&"
import style0 from "./Locale.vue?vue&type=style&index=0&id=7522794c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports